export const UPDATE_CURRENT_TUTORIAL_INDEX = 'UPDATE_CURRENT_TUTORIAL_INDEX';

export function updateComebackTutorialIndex(index: number) {
  return {
    type: UPDATE_CURRENT_TUTORIAL_INDEX,
    currentIndex: index
  };
}
